// A little LED "OPEN sign" style badge for the homepage — glowing neon
// tube text reading "환영" (hwan-yeong), Korean for "welcome". Purely
// decorative/atmospheric, so the animated glow is hidden from screen
// readers in favor of a plain sr-only translation, and the flicker
// respects prefers-reduced-motion (handled in CSS).
export function NeonSign() {
  return (
    <div className="neon-sign" role="img" aria-label="환영 — Korean for “Welcome”">
      <span className="neon-sign__text" aria-hidden="true">
        환영
      </span>
    </div>
  );
}
